import { render, staticRenderFns } from "./NotServiceableModal.vue?vue&type=template&id=5d6ad065"
import script from "./NotServiceableModal.vue?vue&type=script&lang=js"
export * from "./NotServiceableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports